<template>
  <div class="sidebar-body">
    <p class="add-admins-title"><b>Add admin</b></p>
    <p class="add-admins-subtext">
      Search for a user to add as an admin for this tour.
    </p>

    <PlayerSearch
      @selected="selectedUser = $event"
      :disabledUserIds="admins.map((a) => a.user.id)"
    />

    <div class="tip">
      <Tip />
      <p>
        Find users with a Tjing account by searching for their name or email
        address. Users can view their email address in the ‘Profile’ tab.
      </p>
    </div>
    <div class="selected-user-container" v-if="selectedUser">
      <UserProfileAvatar
        :profileImageUrl="selectedUser.profile.profileImageUrl"
        :user="selectedUser"
        :initials="
          selectedUser.firstName.charAt(0) + selectedUser.lastName.charAt(0)
        "
      />
      <p>{{ selectedUser.firstName }} {{ selectedUser.lastName }}</p>
      <span class="remove-icon" @click="selectedUser = null">
        <Remove />
      </span>
    </div>
    <div class="action-buttons">
      <TjingButton title="Cancel" @click="$emit('close')" />
      <TjingButton
        title="Add"
        @click="addAdmin(selectedUser.id)"
        variant="solid"
      />
    </div>
  </div>
</template>

<script>
import Tip from '@/assets/icons/Tip'
import Remove from '@/assets/icons/Remove'
import UserProfileAvatar from '@/components/UIElements/UserProfileAvatar'
import TjingButton from '@/components/UIElements/TjingButton.vue'
import PlayerSearch from '@/components/TjingPlayerSearch.vue'

export default {
  name: 'ManageAdminsSidebar',
  props: {
    admins: {
      type: Array,
      required: true,
    },
    tourId: {
      type: String,
      required: true,
    },
  },
  components: {
    Tip,
    PlayerSearch,
    UserProfileAvatar,
    TjingButton,
    Remove,
  },
  data() {
    return {
      selectedUser: null,
    }
  },
  computed: {},
  methods: {
    async addAdmin(userId) {
      try {
        const newAdmin = await this.$axios({
          headers: { Authorization: this.$store.state.user.sessionInfo.token },
          data: {
            query: `
            mutation {
              AddAdministratorById(tourId:"${this.tourId}",userId:"${userId}"){
                user{
                  id
                }
              }
            }
            `,
          },
        })

        if (newAdmin.data.errors) {
          throw newAdmin.data.errors[0]
        }
        this.$store.dispatch('showMessage', {
          show: true,
          message: 'Admin added',
          type: 'success',
        })
        this.$emit('updated')
      } catch (err) {
        this.$store.dispatch('showMessage', {
          show: true,
          message: err.message || 'Error adding admin',
          type: 'error',
        })
      }
    },
  },
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';
@import '@/styles/Sidebars';
@import '@/styles/manager-settings';

.remove-icon {
  cursor: pointer;
  margin-left: auto;
  svg {
    width: 20px;
    height: 20px;
  }
}
.selected-user-container {
  margin-top: 2rem;

  border: 2px solid $ocean;
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  padding-top: 24px;
  border-top: 1px solid $fog;
  margin-top: 24px;
}

.sidebar-body {
  flex: 1;
  overflow: visible;
  max-width: 420px;
}
.player-search-container {
  margin-top: 1.5rem;
}
.tip {
  margin-top: 1.5rem;
}

.add-admins-title {
  font-size: 1.5rem;
}
.add-admins-subtext {
  font-size: 1rem;
  color: $strom;
  margin-top: 0.625rem;
  line-height: 1.5rem;
}

.current-admins-title {
  padding-bottom: 2rem;
  border-bottom: 1px solid $sleet;
  font-size: 1.5rem;
}
.admins {
  margin-top: 0;
}

@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1200px) {
}
</style>
